import {Component} from "@angular/core";

@Component({
    selector: "fui-page-content",
    styleUrls: ["./page-content.component.scss"],
    templateUrl: "./page-content.component.html"
})
export class FUIPageContentComponent {

}
